import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileMoveMutationAtom = createMutationAtomFactory(
  'files.move',
  ({
    fileId,
    newParentId,
  }: {
    fileId: string;
    newParentId: string | null;
  }) => ({
    filesMoveFile: {
      __args: {
        input: {
          fileId,
          newParentId,
        },
      },
      file: {
        id: true,
        fileName: true,
        parentId: true,
        path: true,
      },
    },
  }),
);
